import {FormConfig} from '../../../models/form-config';
import {FieldType} from '../../../models/field-type';
import {InitialDataSectionFieldKey} from '../../../../core/consts/initial-data-section-field-key.enum';
import {
    InitialDataStateService
} from '../../../../core/services/impl/section-services/initial-data/initial-data-state.service';
import {FieldNameSource} from '../../../models/field-config';
import {Validator} from '../../../models/validator.enum';
import {addYearsToDate, currentYear, today} from '../../../utils/time-utils';
import {DatepickerStartView} from '../../../enums/datepicker-start-view.enum';
import {isCarOne} from '../../../../core/utils/utils';

export class InitialDataSectionConfig {

    constructor(private stateService: InitialDataStateService) {
    }

    createFormConfig(): FormConfig {
        return {
            formKey: 'INITIAL_DATA_SECTION',
            fieldsConfig: [
                {
                    fieldKey: InitialDataSectionFieldKey.REGISTRATION_NUMBER,
                    caption: `INITIAL_DATA_SECTION.FORM_FIELDS.${InitialDataSectionFieldKey.REGISTRATION_NUMBER}`,
                    type: FieldType.TextField,
                    displayInPreviewMode: true,
                    validators: this.stateService.registrationNumberValidators,
                    // appearance: 'outline',
                    // prefixIcon: './assets/images/icons/ue-pl-badge.svg',
                    properties: {
                        textTransform: {
                            type: 'uppercaseAndRemoveSpaces'
                        },
                    }
                },
                {
                    fieldKey: InitialDataSectionFieldKey.UNKNOWN_REGISTRATION_NUMBER,
                    caption: `INITIAL_DATA_SECTION.FORM_FIELDS.${InitialDataSectionFieldKey.UNKNOWN_REGISTRATION_NUMBER}`,
                    type: FieldType.Checkbox,
                    displayInEditableMode: false,
                    checkboxConfig: {
                        readonly: false
                    },
                    analyticsConfig: {
                        fieldNameSource: FieldNameSource.CAPTION
                    }
                },
                {
                    fieldKey: InitialDataSectionFieldKey.BIRTH_DATE,
                    caption: `INITIAL_DATA_SECTION.FORM_FIELDS.${InitialDataSectionFieldKey.BIRTH_DATE}`,
                    type: FieldType.DateField,
                    validators: [Validator.REQUIRED],
                    displayInPreviewMode: true,
                    materialDateFieldConfig: {
                        minDate: '1918-01-01T00:00:00.000Z',
                        maxDate: addYearsToDate(-18, new Date()).toISOString(),
                        startAt: () => 1976,
                        initMinDateWithStartAt: false,
                        startView: DatepickerStartView.MULTI_YEAR,
                    }
                }
            ]
        }
    }
}
